import axiosBackend from "../config/axios/axios-back-end";

const getAllReportCategories = async () => {
  const response = await axiosBackend.get("/api/report-categories");
  return response.data;
};

const getReportCategoryById = async (id) => {
  const response = await axiosBackend.get(`/api/report-categories/${id}`);
  return response.data;
};

const addReportCategory = async (data) => {
  const response = await axiosBackend.post("/api/report-categories", data);
  return response.data;
};

export { getAllReportCategories, getReportCategoryById, addReportCategory };
